import { signInWithPopup } from 'firebase/auth';
import { getFirebaseAuth, getGoogleProvider } from '../config/firebase';
import { request } from './client';

export const apiGoogleLogin = async () => {
  const result = await signInWithPopup(getFirebaseAuth(), getGoogleProvider());
  const idToken = await result.user.getIdToken();
  return request('/auth/admin/google', { method: 'POST', body: { idToken } });
};
